/**
 * Anonymous visitor_id persistence (proposal §8.2).
 * Scoped to the panel origin and partitioned per publishable key.
 * Chat messages stay in-memory only and are purged on WIDGET_CLOSE.
 */

const STORAGE_PREFIX = 'avatar_widget:visitor:';

function storageKey(publishableKey: string): string {
  return `${STORAGE_PREFIX}${publishableKey}`;
}

export function readVisitorId(publishableKey: string): string | undefined {
  if (!publishableKey || typeof localStorage === 'undefined') return undefined;
  try {
    const value = localStorage.getItem(storageKey(publishableKey));
    return value?.trim() || undefined;
  } catch {
    // Private mode / blocked storage — treat as first visit.
    return undefined;
  }
}

export function writeVisitorId(
  publishableKey: string,
  visitorId: string,
): void {
  if (!publishableKey || !visitorId || typeof localStorage === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(storageKey(publishableKey), visitorId);
  } catch {
    // Ignore quota / privacy errors; session still works for this open.
  }
}
